export default {"src":"/_next/static/media/Regulatorypoliciescancome-01.1f163647.svg","height":585,"width":850,"blurWidth":0,"blurHeight":0};